import React from "react";
import EchionStats from "./EchionStats";

function App() {
  return <EchionStats />;
}

export default App;